import React, { MouseEventHandler } from 'react';
import { Button, Divider, Flex } from 'antd';
import { useNavigate } from 'react-router-dom';

import { SAVE, CANCEL } from '../../../shared/contants/actions';

export const Save = ({
    onSave,
    disabled,
    loading,
    saveText,
    hideCancel,
    backRoute,
}: {
    onSave: MouseEventHandler<HTMLElement>;
    disabled: boolean;
    loading?: boolean;
    saveText?: string;
    hideCancel?: boolean;
    backRoute?: string;
}) => {
    const navigate = useNavigate();

    const handleCancel = (backRoute?: string) => {
        if (backRoute) {
            navigate(backRoute);
        } else navigate(-1);
    };

    return (
        <Flex vertical>
            <Divider />

            <Flex vertical={false} gap={24}>
                <Button
                    loading={loading}
                    disabled={disabled}
                    onClick={onSave}
                    type={'primary'}
                >
                    {saveText ? saveText : SAVE}
                </Button>

                {!hideCancel && (
                    <Button
                        onClick={() => handleCancel(backRoute)}
                        type={'default'}
                    >
                        {CANCEL}
                    </Button>
                )}
            </Flex>
        </Flex>
    );
};
